var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement, useRef } from 'react';
import { mergeProps } from '@react-aria/utils';
import { useFocusRing } from '@react-aria/focus';
import { useMergeRefs } from '../hooks';
import useIconSize from './use-icon-size';
import { linkStyle, innerContentStyle } from './styles';
function LinkInternal(_a, ref) {
    var as = _a.as, _b = _a.size, size = _b === void 0 ? 'inherit' : _b, _c = _a.inverted, inverted = _c === void 0 ? false : _c, iconLeft = _a.iconLeft, iconRight = _a.iconRight, children = _a.children, restProps = __rest(_a, ["as", "size", "inverted", "iconLeft", "iconRight", "children"]);
    var Element = as || 'a';
    var _d = useFocusRing(), focusProps = _d.focusProps, isFocusVisible = _d.isFocusVisible;
    var linkRef = useRef(null);
    var iconSize = useIconSize(linkRef);
    var mergedRef = useMergeRefs(linkRef, ref);
    function renderIcon(originalIcon) {
        return originalIcon.props.size
            ? originalIcon
            : cloneElement(originalIcon, {
                size: iconSize,
            });
    }
    return (_jsxs(Element, __assign({}, mergeProps(focusProps, restProps), { ref: mergedRef, css: linkStyle({
            size: size,
            inverted: inverted,
            isFocusVisible: isFocusVisible,
        }) }, { children: [iconLeft && renderIcon(iconLeft), _jsx("span", __assign({ css: innerContentStyle({
                    iconSize: iconSize,
                    hasLeftIcon: !!iconLeft,
                    hasRightIcon: !!iconRight,
                }) }, { children: children })), iconRight && renderIcon(iconRight)] })));
}
export default LinkInternal;
